import { linksData } from "./data"

export const error404 = {
   title: "Ошибка 404",
   subtitle: "Страница не найдена",
   message: "Неправильно набран адрес или такой страницы не существует",
   errorBtnHome: {
      url: linksData[0].url,
      name: "На главную",
   },
}